import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api/axios'

export function EsqueciSenhaPage() {
  const [email, setEmail] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [mensagem, setMensagem] = useState('')
  const [erro, setErro] = useState('')

  async function enviar(e: FormEvent) {
    e.preventDefault()
    setErro('')
    setEnviando(true)
    try {
      const { data } = await api.post('/auth/esqueci-senha', { email })
      setMensagem(data.message)
    } catch (err: any) {
      setErro(err?.response?.data?.error ?? 'Falha ao enviar o e-mail')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="min-h-screen bg-compumaq-preto flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-compumaq-pretoSuave border border-compumaq-dourado/25 rounded-2xl shadow-2xl p-8">
          <img
            src="/compumaq-logo.jpg"
            alt="Compumaq Tecnologia"
            className="w-16 h-16 rounded-2xl mb-4 mx-auto object-cover"
          />
          <h1 className="text-xl font-bold text-compumaq-texto text-center">Esqueci minha senha</h1>
          <p className="text-sm text-compumaq-textoSuave text-center mt-1 mb-6">
            Informe o e-mail cadastrado no seu usuário
          </p>

          {mensagem ? (
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-3 text-sm text-green-400 text-center">
              {mensagem}
            </div>
          ) : (
            <form onSubmit={enviar} className="space-y-5">
              {erro && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                  <p className="text-sm text-red-600">{erro}</p>
                </div>
              )}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-compumaq-textoSuave mb-1">
                  E-mail
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2.5 rounded-lg border border-compumaq-dourado/25 bg-compumaq-preto text-compumaq-texto text-sm focus:outline-none focus:ring-2 focus:ring-compumaq-dourado"
                  placeholder="seu@email.com"
                />
              </div>
              <button
                type="submit"
                disabled={enviando}
                className="w-full bg-compumaq-dourado text-compumaq-texto py-2.5 rounded-lg font-semibold text-sm hover:bg-compumaq-doradoClaro transition-colors disabled:opacity-60"
              >
                {enviando ? 'Enviando...' : 'Enviar instruções'}
              </button>
            </form>
          )}

          <Link to="/login" className="block text-center text-xs text-compumaq-doradoClaro hover:underline mt-4">
            ← Voltar ao login
          </Link>
        </div>
      </div>
    </div>
  )
}
